import { useIsMobile } from "@/hooks/use-mobile";
import AutoFadeBeforeAfter from "@/components/AutoFadeBeforeAfter";
import SimpleBeforeAfter from "@/components/SimpleBeforeAfter";

interface ResponsiveBeforeAfterProps {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
}

const ResponsiveBeforeAfter = ({ before, after, beforeAlt, afterAlt }: ResponsiveBeforeAfterProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <AutoFadeBeforeAfter
        before={before}
        after={after}
        beforeAlt={beforeAlt}
        afterAlt={afterAlt}
      />
    );
  }

  return (
    <SimpleBeforeAfter
      before={before}
      after={after}
      beforeAlt={beforeAlt}
      afterAlt={afterAlt}
    />
  );
};

export default ResponsiveBeforeAfter;
